<template>
  <Layout>
    <div class="flex h-screen overflow-hidden is-main-layout">
      <div class="flex-none">
        <Transition
          enter-active-class="transform transition-all duration-300"
          enter-from-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transform transition-all duration-300"
          leave-from-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <div
            v-show="layoutData.isSidebarOpen"
            class="flex flex-shrink-0 absolute top-0 left-0 h-full z-30"
          >
            <SidebarLLM
              :className="'sidebar-llm'"
              :heightItem="750"
              :promptStartList="gPresetData.beginningMessagesFavoriteList"
              :roomList="layoutData.roomList"
              :menuList="layoutData.dataList"
              :generalList="layoutData.generalList"
              :onClickSubMenu="
                (item) => {
                  onClickConversation(item);
                }
              "
              :onClickLogo="
                () => {
                  console.log('onClickLogo');
                }
              "
              :onClickRoom="
                (item) => {
                  onClickRoom(item);
                }
              "
              :onClickPromptStart="
                (item) => {
                  onClickPromptStart(item);
                }
              "
              :onClickCreateConversation="onClickCreateConversation"
              :onClickRenameConversation="onClickRenameConversation"
              :onClickDeleteConversation="onClickDeleteConversation"
              :onClickExportConversation="onClickExportConversation"
              :onClickShareConversation="onClickShareConversation"
              :onLoadMore="onLoadMoreConversation"
              :onLoadMoreGeneral="onLoadMoreGeneral"
              :onClickSearchConversation="onClickSearchConversation"
              @closeSidebar="layoutData.isSidebarOpen = false"
            />
          </div>
        </Transition>
      </div>
      <div
        :class="`flex-1 conversaion-container transition-[margin] duration-300 w-full 
          ${layoutData.isSidebarOpen ? '2xl:ml-72 xl:ml-72 lg:ml-72 ml-0' : 'ml-0'}
        `"
      >
        <div
          class="absolute ease-in-out top-5 xs:top-4 left-3 cursor-pointer hover:scale-105 transition-all"
        >
          <img
            class="min-w-8 max-w-8 min-h-8 max-h-8"
            src="/images/icons/ic-hamburger.svg"
            @click="layoutData.isSidebarOpen = !layoutData.isSidebarOpen"
          />
        </div>
        <div
          :class="`flex-none ${
            layoutData.isSidebarOpen ? 'ml-0' : 'ml-12 xs:ml-9'
          }`"
        >
          <CustomTopbarContainer />
        </div>
        <slot />
      </div>
    </div>

    <Notifications 
        position="top center" 
        :group="'tailwind'" 
        :max="1"
        animation-type="velocity" 
        :animation="animation"
        >
      <template #body="props">
        <Toast
          class="mt-2 mr-6"
          :isError="props.item.data.isError"
          :isWarning="props.item.data.isWarning"
          :isNotice="props.item.data.isNotice"
          :isDisabled="props.item.data.isDisabled"
          :label="props.item.text"
          :onClick="props.close"
        />
      </template>
    </Notifications>

    <!-- Loading Overlay -->
    <LoadingOverlay
      v-if="isShowLoading"
      :isFlow="true"
      :isPulse="false"
      :isCircleFade="false"
    />

    <!-- :size="layoutData.isResponeSize ? 'small' : 'medium'" -->
    <ModalRename
      v-if="layoutData.modalData.isShowRenameConversationModal"
      :size="'small'"
      :showIconClose="true"
      :showIcon="false"
      :showButton2nd="true"
      :showTitle="true"
      :iconSwap="false"
      :slotSwap="false"
      :onClose="
        () => {
          layoutData.modalData.isShowRenameConversationModal = false;
        }
      "
      :onConfirm="onClickConfirmRenameModal"
      :textTitle="$t('modal.title1')"
      :menuName="layoutData.modalData.itemData.conversationName"
      :onChangeInput="(value) => onChangeInputModal('conversationName', value)"
      :btnTextSuccess="$t('modal.buttonConfirm')"
      :btnTextCancel="$t('modal.buttonCancel')"
    />

    <ModalCustomContainer
      v-if="layoutData.modalData.isShowDeleteConversationModal"
      :size="'small'"
      imageIconSrc="/images/icons/ic-trash-circle-gradeint-red.svg"
      :showIconClose="true"
      :showIcon="false"
      :showButton2nd="true"
      :showTitle="true"
      :iconSwap="false"
      :slotSwap="false"
      :onClose="
        () => {
          layoutData.modalData.isShowDeleteConversationModal = false;
        }
      "
      :onConfirm="onClickConfirmModalDelete"
      :textTitle="$t('modal.title2')"
      :textBody="$t('modal.messageDoYouWantToDelete')"
      :textBodySecondary="`${layoutData.modalData.itemData.name} ?`"
      btnSuccessClassName="!bg-[#FD5C5C] !text-xl hover:!bg-[#E03131]"
      btnCancelClassName=" !text-[#734EB0] !text-xl !border-[#734EB0] hover:!bg-[#F3E8FF]"
      :btnTextSuccess="$t('modal.buttonConfirm')"
      :btnTextCancel="$t('modal.buttonCancel')"
    />

    <ModalExport
      v-if="layoutData.modalData.isShowExportConversationModal"
      size="small"
      :showIconClose="true"
      :showIcon="false"
      :showButton2nd="false"
      :showTitle="true"
      :iconSwap="false"
      :slotSwap="false"
      :onClose="
        () => {
          layoutData.modalData.isShowExportConversationModal = false;
        }
      "
      :onConfirm="onConfirmExportConversation"
      :textTitle="'Export this conversation'"
      :onChangeSelect="onChangeSelectExport"
      :btnTextSuccess="'Submit'"
      :btnTextCancel="$t('modal.buttonCancel')"
    />

    <ModalShare
      v-if="layoutData.modalData.isShowShareConversationModal"
      size="small"
      :showIconClose="true"
      :showIcon="false"
      :showButton2nd="false"
      :showTitle="true"
      :iconSwap="false"
      :slotSwap="false"
      :onClose="
        () => {
          layoutData.modalData.isShowShareConversationModal = false;
        }
      "
      :onConfirm="
        () => {
          layoutData.modalData.isShowShareConversationModal = false;
        }
      "
      :textTitle="'Share this conversation'"
      subtitle="Internal only - THAI access required"
      :sharedUrl="`${runtimeConfig.public.baseUrl}/shared/${layoutData.modalData.itemData.id}`"
      :btnTextSuccess="'Close'"
    />

    <ModalSearch
      v-if="layoutData.modalData.isShowSearchModal"
      isScrollSearch
      size="small"
      :textTitle="'Search'"
      :optionList="layoutData.searchResultList"
      :hasMore="layoutData.searchHasMore"
      :isLoading="layoutData.searchIsLoading"
      :onSearch="onSearchModalSearch"
      :onLoadMore="onSearchModalLoadMore"
      :onChangeSelect="onSearchModalSelect"
      :onClose="
        () => {
          layoutData.modalData.isShowSearchModal = false;
        }
      "
      "
    />

    <!-- Overlay -->
    <div
      v-show="layoutData.isSidebarOpen"
      class="fixed inset-0 z-20 bg-black/40 lg:hidden xl:hidden 2xl:hidden"
      @click="layoutData.isSidebarOpen = false"
    />
  </Layout>
</template>

<script setup>
import { ModelConversationDetail } from '~/services/conversation/dto/conversation.detail.dto';
import { useI18n } from 'vue-i18n';
import { ENUM } from '~/plugins/constants/enum';

const isShowLoading = useIsShowLoading();
console.log('🚀 ~ isShowLoading:', isShowLoading.value);

const { $constants, $services, $nats, $functions } = useNuxtApp();
const gConversationData = useConversationData();
const gConversationActiveId = useConversationActiveId();
const gIsShowLoading = useIsShowLoading();
const gServiceData = useServiceData();
const gPresetData = usePresetData();
const gPresetActiveId = usePresetActiveId();
const gPromptStartActiveId = usePromptStartActiveId();
const router = useRouter();
const runtimeConfig = useRuntimeConfig();
const gIsLimit = useIsLimit();
const gUserAuthData = useUserAuthData();
const gLimitMessage = useLimitMessage();
useSessionExpiry();

const layoutData = reactive({
  roomList: [],
  promptStartList: [],
  dataList: [],
  generalList: [],
  searchResultList: [],
  modalData: {
    isShowRenameConversationModal: false,
    isShowDeleteConversationModal: false,
    isShowExportConversationModal: false,
    isShowShareConversationModal: false,
    isShowSearchModal: false,
    itemData: {},
    exportValueSelected: undefined,
    searchValueSelected: undefined,
  },
  isResponeSize: false,
  isSidebarOpen: true,
  conversationPage: 1,
  conversationLimit: 20,
  conVersationHasMore: true,
  conversationIsLoading: false,
  generalPage: 1,
  generalLimit: 20,
  generalHasMore: true,
  generalIsLoading: false,

  searchPage: 1,
  searchLimit: 10,
  searchIsLoading: false,
  searchHasMore: true,
  searchType: 'general', // 'room' or 'general'
});


const animation = computed(() => ({
  /**
   * Animation function
   * 
   * Runs before animating, so you can take the initial height, width, color, etc
   * @param  {HTMLElement}  element  The notification element
   */
  enter(element) {
    let height = element.clientHeight;
    return {
      // animates from 0px to "height"
      height: [height, 0],
    };
  },
  leave: {
    height: 0,
    opacity: 0
  }
}));

onMounted(async () => {
  gIsShowLoading.value = true;
  await getConversarion();
  await getPresetList();
  await onClickCreateConversation();
  // await getPresetDetail();
  // await $nats.connect();
  gServiceData.value.getConversarion = getConversarion;

  // if (window.innerWidth <= 480) {
  if (window.innerWidth <= 1024) {
    layoutData.isResponeSize = true;
  } else {
    layoutData.isResponeSize = false;
  }

  // Add resize listener to update responsive state
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1024) {
      layoutData.isResponeSize = true;
    } else {
      layoutData.isResponeSize = false;
    }
  });

  gIsShowLoading.value = false;
});

const getConversarion = async (reset = true, isIgnorePage = false) => {
  if (!reset && !layoutData.conVersationHasMore) return;
  layoutData.conversationIsLoading = true;
  try {
    if (reset) {
        layoutData.conversationPage = 1;
        layoutData.conVersationHasMore = true;
        layoutData.generalPage = 1;
        layoutData.generalHasMore = true;
        layoutData.dataList = [];
        layoutData.generalList = [];
      }

    const params = {
      orderBy: 'createdAt',
      orderType: 'desc',
      page: layoutData.conversationPage,
      limit: layoutData.conversationLimit,
      count: true,
      ignorePage: isIgnorePage ? 'true' : 'false',
      isOnlyRoom: true,
      generalActiveId: runtimeConfig.public.defaultPresetActiveId, 
    };
    const conversationService = $services.conversationController();
    // const res = await conversationService.getConversation(params);
    const res = await conversationService.getConversationAndHistory(params);
    const newConversationList = res.data || [];
    layoutData.dataList = [...layoutData.dataList, ...newConversationList];

    if (reset) {
      await getGeneralList(isIgnorePage);
    }
    // layoutData.generalList = [...layoutData.generalList, ...newConversationList];
    
    const totalItems = res.totalItems ?? 0;
    layoutData.conVersationHasMore = layoutData.dataList.length < totalItems;
  } finally {
    layoutData.conversationIsLoading = false;
  }
};

const getGeneralList = async (isIgnorePage = false) => {
  if (!layoutData.generalHasMore) return;
  
  const params = {
    orderBy: 'createdAt',
    orderType: 'desc',
    page: layoutData.generalPage,
    limit: layoutData.generalLimit,
    count: true,
    ignorePage: isIgnorePage ? 'true' : 'false',
    isOnlyGeneral: true,
    generalActiveId: runtimeConfig.public.defaultPresetActiveId,
  };
  const conversationService = $services.conversationController();
  const res = await conversationService.getConversationAndHistory(params);
  const newConversationList = res.data || [];
  layoutData.generalList = [...layoutData.generalList, ...newConversationList];

  const totalItems = res.totalItems ?? 0;
  layoutData.generalHasMore = layoutData.generalList.length < totalItems;
};

const onClickSearchConversation = async (searchType = 'general') => {
  layoutData.searchPage = 1;
  layoutData.searchHasMore = true;
  layoutData.searchResultList = [];
  layoutData.searchType = searchType;
  layoutData.modalData.isShowSearchModal = true;
};


const onLoadMoreConversation = async () => {
  layoutData.conversationPage += 1;
  await getConversarion(false);
};

const onLoadMoreGeneral = async () => {
  layoutData.generalPage += 1;
  await getGeneralList(false);
};

const handleSearchSidebarList = async (searchQuery = '') => {
  if (!layoutData.searchHasMore && layoutData.searchPage > 1) {
    return;
  }
  
  layoutData.searchIsLoading = true;
  try {
    const params = {
      orderBy: 'createdAt',
      orderType: 'desc',
      page: layoutData.searchPage,
      limit: layoutData.searchLimit,
      count: true,
      searchQuery: searchQuery,
    };

    // ค้นหาตาม type ที่เลือก
    if (layoutData.searchType === 'room') {
      params.isOnlyRoom = true;
      params.generalActiveId = runtimeConfig.public.defaultPresetActiveId;
    } else if (layoutData.searchType === 'general') {
      params.isOnlyGeneral = true;
      params.generalActiveId = runtimeConfig.public.defaultPresetActiveId;
    }
    
    const conversationService = $services.conversationController();
    const res = await conversationService.getConversationAndHistory(params);
    const newConversationList = res.data || [];
    
    if (layoutData.searchPage === 1) {
      layoutData.searchResultList = newConversationList;
    } else {
      layoutData.searchResultList = [...layoutData.searchResultList, ...newConversationList];
    }

    const totalItems = res.totalItems ?? 0;
    layoutData.searchHasMore = layoutData.searchResultList.length < totalItems;
  } catch (error) {
  } finally {
    layoutData.searchIsLoading = false;
  }
};

const onSearchModalSearch = async (searchText) => {
  layoutData.searchPage = 1;
  layoutData.searchHasMore = true;
  layoutData.searchResultList = [];
  await handleSearchSidebarList(searchText);
};

const onSearchModalLoadMore = async () => {
  layoutData.searchPage += 1;
  await handleSearchSidebarList(layoutData.modalData.searchValueSelected?.text || '');
};

const onSearchModalSelect = async (value) => {
  layoutData.modalData.searchValueSelected = value;
  if (value?.data) {
    await onClickConversation(value.data);
    layoutData.modalData.isShowSearchModal = false;
  }
};

const onClickConversation = async (item) => {
  // const conversationData = layoutData.dataList[index];
  gIsLimit.value = false;
  if (router.currentRoute.value.path !== '/') {
    await router.push('/');
  }
  const conversationData = item;
  if (conversationData && conversationData.id !== gConversationActiveId.value) {
    gServiceData.value.clearPageDataIndex();

    gConversationActiveId.value = conversationData.id;
    gPresetActiveId.value = conversationData.presetId;

    const params = conversationData.id;
    const conversationService = $services.conversationController();
    const data = await conversationService.getConversationDetail(params);

    data.conversationMessageList = await $functions.downloadMessageFileList(
      data.conversationMessageList
    );

    // await $nats.unsubscribe();
    // $nats.subscribe(data);
    gConversationData.value = data;
    gPresetData.value = await getPresetDetail();
    await handleCheckQuota();
  }
  await handleCloseSidebar();
};

const onClickCreateConversation = async () => {
  // await $nats.unsubscribe();
  gIsLimit.value = false;
  await gServiceData.value.getPresetList();
  gServiceData.value.clearPageDataIndex();
  gConversationData.value = new ModelConversationDetail();
  gConversationActiveId.value = '';
  gPromptStartActiveId.value = '';
  gPresetActiveId.value = '';
  gPresetData.value = await getPresetDetail();
  // gPresetData.value.beginningMessagesList = await getPresetDetail();
  // gPresetData.value.beginningMessagesFavoriteList = [];

  await handleCheckQuota();
  await handleCloseSidebar();
};

// Room (Preset)
const getPresetList = async () => {
  const params = {
    orderType: 'desc',
    orderBy: 'createdAt',
    ignorePage: 'true',
  };
  const presetAssoService = $services.presetAssoController();
  const presetList = await presetAssoService.getPresetAssociationPresetActive(
    params
  );
  const workflowService = $services.workflowController();
  const workflowList = await workflowService.getWorkflowRuntime(params);

  layoutData.roomList = [
    // {
    //   isGroup: true,
    //   text: '--- Workflow ---',
    // },
    // ...workflowList.map((e) => {
    //   return {
    //     text: e.className || `workflow_${e.id}`,
    //     value: `workflow_${e.id}`,
    //     data: e,
    //   };
    // }),
    // {
    //   isGroup: true,
    //   text: '--- Preset ---',
    // },
    ...presetList
      .map((e) => {
        return {
          text: e.name,
          value: e.id.toString(),
          data: e,
          name: e.name,
          id: e.id,
        };
      })
      .filter(
        (e) =>
          e.id !== runtimeConfig.public.defaultPresetActiveId &&
          e.presetId !== runtimeConfig.public.defaultPresetId &&
          e.name
      ),
  ];
};

const onClickRoom = async (value) => {
  gIsLimit.value = false;
  if (gConversationData.value.id) {
    await onClickCreateConversation();
    await onClickRoom(value);
  } else {
    gConversationData.value.presetActiveId = value.value;
    const presetSelected = layoutData.roomList?.filter(
      (e) => e.value === value.value
    )[0];

    if (presetSelected) {
      if (presetSelected.data.type === 'workflow') {
        gConversationData.value = new ModelConversationDetail({
          workflowActiveId: presetSelected.data.id,
          presetActiveId: value.value,
        });
      }
      gPresetActiveId.value = presetSelected.data.presetId;
      gConversationData.value.presetId = presetSelected.data.presetId;
      gPresetData.value = await getPresetDetail();

      console.log(
        'gPresetData',
        gPresetData.value,
        gPresetActiveId.value,
        value
      );
      gConversationData.value.isPresetSelected = true;
    }
  }

  await handleCheckQuota();
  await handleCloseSidebar();
};

const getPresetDetail = async () => {
  const params = gConversationData.value.presetId;
  console.log('getPresetDetail params', params);
  if (params) {
    const presetAssoService = $services.presetAssoController();
    const data = await presetAssoService.getPresetAssociationPreset(params);

    if (data.avatarFilePath) {
      const presetService = $services.presetController();
      data.avatarFile.url = URL.createObjectURL(
        await presetService.getPresetFile(data.avatarFilePath)
      );
    }
    console.log('getPresetDetail', data);
    // gPresetData.value = data;
    return data;
  } else {
    return new ModelGETPresetAssociationPreset();
  }
};

//! Prompt Starter
// gPresetData.beginningMessagesList
const onClickPromptStart = async (value) => {
  if (value) {
    gConversationData.value.beginningMessageId = value.id;
    gConversationData.value.beginningMessageContent = value.content;
    gPromptStartActiveId.value = value.id;

    // Call the page's submit handler to fill input and send message
    if (gServiceData.value.onClickPromptStartSubmit) {
      gServiceData.value.onClickPromptStartSubmit(value.message);
    }
  }
  await handleCloseSidebar();
};

//
// Modal delete
//
const onClickDeleteConversation = (item) => {
  if (item) {
    layoutData.modalData.isShowDeleteConversationModal = true;
    layoutData.modalData.itemData = item;
  }
};

const onClickConfirmModalDelete = async () => {
  gIsShowLoading.value = true;
  const params = {
    id: layoutData.modalData.itemData.id,
  };
  const conversationService = $services.conversationController();
  await conversationService.deleteConversation(params);
  await getConversarion();
  console.log(
    'gConversationActiveId',
    gConversationActiveId.value,
    layoutData.modalData.itemData.id
  );
  if (gConversationActiveId.value === layoutData.modalData.itemData.id) {
    onClickCreateConversation();
  }
  layoutData.modalData.isShowDeleteConversationModal = false;
  gIsShowLoading.value = false;
};

//
// Modal Rename
//
const onClickRenameConversation = async (item) => {
  if (item) {
    layoutData.modalData.isShowRenameConversationModal = true;
    layoutData.modalData.menuName = item.name;
    layoutData.modalData.itemData = item;
    layoutData.modalData.itemData.conversationName = item.name;
  }
};

const onClickExportConversation = async (item) => {
  if (item) {
    layoutData.modalData.isShowExportConversationModal = true;
    layoutData.modalData.menuName = item.name;
    layoutData.modalData.itemData = item;
  }
};

const onClickShareConversation = async (item) => {
  if (item) {
    layoutData.modalData.isShowShareConversationModal = true;
    layoutData.modalData.menuName = item.name;
    layoutData.modalData.itemData = item;
  }
};

const onChangeInputModal = (target, value) => {
  layoutData.modalData.itemData[target] = value;
};

const onClickConfirmRenameModal = async () => {
  if (layoutData.modalData.itemData.conversationName.length) {
    gIsShowLoading.value = true;
    const params = {
      id: layoutData.modalData.itemData.id,
      name: layoutData.modalData.itemData.conversationName,
    };
    const conversationService = $services.conversationController();
    await conversationService.putConversation(params);

    layoutData.dataList = layoutData.dataList.map((e) => {
      if (e.id === layoutData.modalData.itemData.id) {
        e.name = layoutData.modalData.itemData.conversationName;
      }
      return e;
    });
    layoutData.modalData.isShowRenameConversationModal = false;
    gIsShowLoading.value = false;
  }
};

const onChangeSelectExport = (value) => {
  layoutData.modalData.exportValueSelected = value;
};

const onConfirmExportConversation = async () => {
  if (layoutData.modalData.exportValueSelected !== undefined) {
    const params = {
      id: layoutData.modalData.itemData.id,
      type: layoutData.modalData.exportValueSelected,
    };
    const conversationService = $services.conversationController();
    const data = await conversationService.exportConversation(params);

    if (layoutData.modalData.exportValueSelected === ENUM.EXPORT_TYPE.TXT) {
      $functions.downloadTextFile(
        `${layoutData.modalData.itemData.name || 'conversation'}.txt`,
        data
      );
    } else if (
      layoutData.modalData.exportValueSelected === ENUM.EXPORT_TYPE.PDF
    ) {
      $functions.downloadPDFFile(
        `${layoutData.modalData.itemData.name || 'conversation'}.pdf`,
        data
      );
    }
  }
  layoutData.modalData.isShowExportConversationModal = false;
};

const handleCheckQuota = async () => {
  const params = {
    // presetVersionKey: gPresetData.value.versionKey,
    userId: gUserAuthData.value.id,
    model: gConversationData.value.modelActiveName,
  };
  const quotaService = $services.quotaController();
  const data = await quotaService.checkQuota(params);
  if (data.quotaWarning) {
    $functions.notify.info({ text: data.quotaWarning });
    gLimitMessage.value = data.quotaWarning;
    if (data.isLimit) {
      gIsLimit.value = true;
    }
  }
};

const handleCloseSidebar = () => {
  if (layoutData.isResponeSize) {
    layoutData.isSidebarOpen = false;
  }
};

watch(
  () => layoutData.isResponeSize,
  () => (layoutData.isSidebarOpen = false)
);
</script>

<style lang="scss">
.is-main-layout {
  display: flex;
  font-family: $typography-font-family-primary;
  background: linear-gradient(180deg, #ffffff 0%, #d1c6e6 100%);

  .conversaion-container {
    display: flex;
    flex-direction: column;
    padding: clamp(8px, 2vw, 16px);
    height: 100%;
  }
}
</style>
